import * as React from "react";
import { themePalette } from "../../theme";

export const PlusCircleFill = (): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C5.72144 0.0500782 3.83099 0.826291 2.32864 2.32864C0.826291 3.83099 0.0500782 5.72144 0 8C0.0500782 10.2786 0.826291 12.169 2.32864 13.6714C3.83099 15.1737 5.72144 15.9499 8 16C10.2786 15.9499 12.169 15.1737 13.6714 13.6714C15.1737 12.169 15.9499 10.2786 16 8C15.9499 5.72144 15.1737 3.83099 13.6714 2.32864C12.169 0.826291 10.2786 0.0500782 8 0Z"
      fill={themePalette.redDark}
    />
    <path
      d="M7.49998 3.3335C7.22384 3.3335 6.99998 3.55735 6.99998 3.8335V7.00016L3.83331 7.00016C3.55717 7.00016 3.33331 7.22402 3.33331 7.50016V8.50016C3.33331 8.7763 3.55717 9.00016 3.83331 9.00016H6.99998V12.1668C6.99998 12.443 7.22384 12.6668 7.49998 12.6668H8.49998C8.77612 12.6668 8.99998 12.443 8.99998 12.1668V9.00016H12.1666C12.4428 9.00016 12.6666 8.77631 12.6666 8.50016V7.50016C12.6666 7.22402 12.4428 7.00016 12.1666 7.00016L8.99998 7.00016V3.8335C8.99998 3.55735 8.77612 3.3335 8.49998 3.3335H7.49998Z"
      fill="white"
    />
  </svg>
);
